module.exports = __webpack_public_path__ + "assets/graphic-camera.a200ff4f.svg";